import { ConfigModel } from "./Models";
import { getEnvConfigKey } from "./Utils/environment.utils";

const ENV_CONFIG_URL =
  "https://dev-rms-config-294f655d18b3.s3.ap-south-1.amazonaws.com/external-config.json";

const loadConfig = (): ConfigModel => {
  try {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", ENV_CONFIG_URL, false);
    xhr.send(null);

    if (xhr.status === 200) {
      const data = JSON.parse(xhr.responseText);
      return getEnvConfigKey(data);
    } else {
      console.error(`Failed to load configuration. Status: ${xhr.status}`);
      return require("./Prod.json");
    }
  } catch (error) {
    return require("./Prod.json");
  }
};
const Config: ConfigModel = loadConfig();

export default Config;
